import { getData, postData } from '../utils/api';

// Product Wise Month Wise Data
export const getProductMonthWiseData = async (params) => {

  const { page = 1, limit = 50, sortField = 'total_net_amount', sortValue = 'DESC', startDate, endDate, postingAccount, zone, exportToCsv, state, productName, productSku, productSkus } = params;
  try {

    let url = `/data/order/product-wise-month-wise-data?page=${page}&limit=${limit}&sortField=${sortField}&sortValue=${sortValue}&startMonth=${startDate}&endMonth=${endDate}`;

    if (zone) {
      url += `&zone=${zone}`;
    }
    if (exportToCsv) {
      url += `&exportToCsv=${exportToCsv}`;
    }
    if (postingAccount) {
      url += `&postingAccount=${postingAccount}`;
    }
    if (state) {
      url += `&state=${encodeURIComponent(state)}`;
    }
    if (productSkus && String(productSkus).trim()) {
      url += `&productSkus=${encodeURIComponent(String(productSkus).trim())}`;
    } else if (productSku && String(productSku).trim()) {
      url += `&productSku=${encodeURIComponent(String(productSku).trim())}`;
    } else if (productName) {
      url += `&productName=${encodeURIComponent(productName)}`;
    }
    const response = await getData(url);


    return response.data;
  } catch (error) {
    throw error;
  }
};

// Month Wise Stats
export const getMonthWiseStats = async (params) => {
  const { startDate, endDate, statType = 'postingAccount', postingAccount, zone, productName, baseSku } = params;
  let url = `/data/order/month-wise-stats?startMonth=${startDate}&endMonth=${endDate}&statType=${statType}`;
  if (postingAccount) {
    url += `&postingAccount=${encodeURIComponent(postingAccount)}`;
  }
  if (zone) {
    url += `&zone=${encodeURIComponent(zone)}`;
  }
  if (baseSku && String(baseSku).trim()) {
    url += `&baseSku=${encodeURIComponent(String(baseSku).trim())}`;
  } else if (productName) {
    url += `&productName=${encodeURIComponent(productName)}`;
  }
  try {
    const response = await getData(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Day Wise Stats
export const getDayWiseStats = async (params) => {
  const { startDate, endDate, statType = 'postingAccount', postingAccount, zone, state, productName, baseSku, groupBy = "day" } = params;

  let url = `/data/order/day-wise-stats?startMonth=${startDate}&endMonth=${endDate}&statType=${statType}&groupBy=${groupBy}`;
  if (postingAccount) {
    url += `&postingAccount=${encodeURIComponent(postingAccount)}`;
  }
  if (zone) {
    url += `&zone=${encodeURIComponent(zone)}`;
  }
  if (state) {
    url += `&state=${encodeURIComponent(state)}`;
  }
  if (baseSku && String(baseSku).trim()) {
    url += `&baseSku=${encodeURIComponent(String(baseSku).trim())}`;
  } else if (productName) {
    url += `&productName=${encodeURIComponent(productName)}`;
  }

  try {
    const response = await getData(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Product Wise Day Wise Data
export const getProductDayWiseData = async (params) => {
  const {
    page = 1,
    limit = 50,
    sortField = 'total_net_amount',
    sortValue = 'DESC',
    startDate,
    endDate,
    postingAccount,
    state,
    zone,
    productName,
    productSku,
    productSkus,
    exportToCsv,
    groupBy = "day"
  } = params;

  try {
    let url = `/data/order/product-wise-day-wise-data?page=${page}&limit=${limit}&sortField=${sortField}&sortValue=${sortValue}&startDate=${startDate}&endDate=${endDate}&groupBy=${groupBy}`;
    if (zone) {
      url += `&zone=${zone}`;
    }
    if (exportToCsv) {
      url += `&exportToCsv=${exportToCsv}`;
    }
    if (postingAccount) {
      url += `&postingAccount=${postingAccount}`;
    }
    if (state) {
      url += `&state=${encodeURIComponent(state)}`;
    }
    if (productSkus && String(productSkus).trim()) {
      url += `&productSkus=${encodeURIComponent(String(productSkus).trim())}`;
    } else if (productSku && String(productSku).trim()) {
      url += `&productSku=${encodeURIComponent(String(productSku).trim())}`;
    } else if (productName) {
      url += `&productName=${encodeURIComponent(productName)}`;
    }
    const response = await getData(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchProductAnalytics = async ({ startDate, endDate, productName, productSku }) => {
  const params = new URLSearchParams({ startDate, endDate });
  if (productSku && String(productSku).trim()) {
    params.append("productSku", String(productSku).trim());
  } else if (productName && String(productName).trim()) {
    params.append("productName", String(productName).trim());
  }
  const response = await getData(`/data/order/product-analytics?${params.toString()}`);
  return response.data;
};

// Get all products (paginated)
export const getAllProducts = async (params = {}) => {
  const { page = 1, limit = 50, searchKey = "", postingAccount = "" } = params;
  try {
    let url = `/data/product?page=${page}&limit=${limit}`;
    if (searchKey && String(searchKey).trim()) {
      url += `&searchKey=${encodeURIComponent(String(searchKey).trim())}`;
    }
    if (postingAccount && String(postingAccount).trim()) {
      url += `&postingAccount=${encodeURIComponent(String(postingAccount).trim())}`;
    }
    const response = await getData(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Hourly Sales (dedicated API)
export const getHourlySales = async ({ startMonth, endMonth, postingAccount, zone, state, productName, baseSku }) => {
  const params = new URLSearchParams({
    startMonth,
    endMonth,
  });
  if (postingAccount) params.append('postingAccount', postingAccount);
  if (zone) params.append('zone', zone);
  if (state) params.append('state', state);
  if (baseSku && String(baseSku).trim()) params.append("baseSku", String(baseSku).trim());
  if (productName && String(productName).trim()) params.append("productName", String(productName).trim());
  const response = await getData(`/data/order/hourly-sales?${params.toString()}`);
  return response;
};

// Sales Comparison (Base vs Compare)
// productSku: when set, filters to orders with this SKU (from product dropdown selection)
export const getSalesComparisonData = async ({ baseStart, baseEnd, compareStart, compareEnd, platform, productSku }) => {
  const params = new URLSearchParams({
    baseStart,
    baseEnd,
    compareStart,
    compareEnd,
  });
  
  if (platform && platform !== "all") {
    params.append('platform', platform);
  }
  
  if (productSku && productSku.trim() !== "") {
    params.append('productSku', productSku.trim());
  }
  
  const response = await getData(`/data/order/comparison-data?${params.toString()}`);
  return response.data;
};

export const getShopifyCampaignAnalytics = async ({ startDate, endDate }) => {
  return postData("/data/order/shopify-campaign-analytics", {
    startDate,
    endDate,
  });
};

export const exportShopifyCampaignAnalytics = async ({ startDate, endDate }) => {
  return postData(
    "/data/order/shopify-campaign-analytics",
    { startDate, endDate, exportToCsv: true },
    { responseType: "blob" }
  );
};